import React from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'

export const ListCuti: React.FC = () => {
  return (
    <Section title="Dashboard Pengajuan Cuti">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          title={'Pengajuan Cuti'}
          src={env.iFrameMetabaseCuti}
          frameBorder="0"
          width="100%"
          height="600"
        ></iframe>
      </div>
    </Section>
  )
}
